import { z } from 'zod';
import { apiEnvelope, backendDate, numericString } from './backend.schema';

/** Código que el backend puede enviar como string o número; se expone como string. */
const code = z.union([z.string(), z.number()]).transform(String);

/** Toneladas a kg, redondeado a kg enteros para evitar errores de coma flotante. */
const tonsToKg = (t: number) => Math.round(t * 1000);

/** Orden de curado abierta tal como la devuelve `GET /seeds/open`. */
export const OrdenCuradoApiSchema = z
  .object({
    processOrderCode: code,
    productDescription: z.string(),
    batchCode: code,
    openDate: backendDate,
    consumedQuantity: numericString,
    declaredQuantity: numericString,
    bagCount: numericString,
    shrinkage: numericString.nullable(),
  })
  .transform((o) => ({
    orden: o.processOrderCode,
    estado: 'abierta' as OrdenCuradoEstado,
    lote: o.batchCode,
    producto: o.productDescription,
    apertura: o.openDate,
    cierre: null as string | null,
    consumido: tonsToKg(o.consumedQuantity),
    entero: tonsToKg(o.declaredQuantity),
    bolsones: o.bagCount,
    partido: o.shrinkage == null ? null : tonsToKg(o.shrinkage),
  }));

/** Lote activo en curado tal como lo devuelve `GET /seeds/active-lots`; kilos como string. */
export const ProgresoCuradoApiSchema = z
  .object({
    processOrderCode: code,
    batchCode: code,
    declaredKg: numericString,
    consumedKg: numericString,
    limitKg: numericString,
    remainingKg: numericString,
  })
  .transform((l) => ({
    orden: l.processOrderCode,
    lote: l.batchCode,
    consumido: l.consumedKg,
    declarado: l.declaredKg,
    tope: l.limitKg,
    restante: l.remainingKg,
  }));

export const OrdenesCuradoRespSchema = apiEnvelope(z.array(OrdenCuradoApiSchema)).transform((r) => r.data);
export const ProgresoCuradoRespSchema = apiEnvelope(z.object({ items: z.array(ProgresoCuradoApiSchema) })).transform(
  (r) => r.data.items,
);

export type OrdenCuradoEstado = 'abierta' | 'cerrada';
export type OrdenCurado = z.output<typeof OrdenCuradoApiSchema>;
export type ProgresoCurado = z.output<typeof ProgresoCuradoApiSchema>;
